import React, { useState, useEffect, memo, Fragment, useMemo } from "react";
import { Row, Col, Dropdown, Button, Form, Image, Spinner, Alert } from "react-bootstrap";
import "./StatistikHeader.css";
import PrimerChart2 from './components/primer-chart-2';
import Card from "../../components/Card";

//Dashboar Service
import DashboardService from "../../services/pbumku/DashboardService";

// AOS
import AOS from "aos";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";

//swiper
import SwiperCore, { Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";

//Count-up
import CountUp from "react-countup";

// Redux Selector / Action
import { useSelector } from "react-redux";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import { get } from "sortablejs";
import { LuHeading2 } from "react-icons/lu";

// install Swiper modules
SwiperCore.use([Navigation]);

const DashPrimer = memo((props) => {
  const [permohonanCnt, setPermohonanCnt] = useState(0);
  const [sertifikatCnt, setSertifikatCnt] = useState(0);
  const [verifyCnt, setVerifyCnt] = useState(0);
  const [perizinans, setPerizinans] = useState([]);
  const [sptCnt, setSptCnt] = useState(0);
  const [provinsi, setProvinsi] = useState([]);
  const [upi, setUpi] = useState(0);
  const [haccp, setHaccp] = useState(0);
  const [skv, setSkv] = useState(0);
  const [upn, setUpn] = useState(0);
  let DashService = useMemo(() => new DashboardService(), []);
  const [frequensi, setFrequensi] = useState([]); // data frequensi
  const [frequensiNegara, setFrequensiNegara] = useState([]);
  const [frequensiUpt, setFrequensiUpt] = useState([]); // data frequensi upt
  const [frequensiTrader, setFrequensiTrader] = useState([]);
  const [jumfreq, setJumfreq] = useState(0); // jumlah data frequensi
  const [jumVol, setJumVol] = useState(0); // jumlah data volume
  const [nilaiIDR, setNilaiIDR] = useState(0); // Nilai Rupiah
  const [nilaiUSD, setNilaiUSD] = useState(0); // Nilai USD
  const [bulanTahun, setBulanTahun] = useState([]);
  const [namaUPT, setNamaUPT] = useState(null);
  const [isVisibleUpt, setIsVisibleUpt] = useState(false); // check yang login, dari upt atau dari pusat
  const [isNol, setIsNol] = useState(false); // data sudah ada atau belum
  const [isTrader, setIsTrader] = useState(false); // check yang login, dari trader atau bukan
  const [bentuk, setBentuk] = useState([]);
  const [tahuns, setTahuns] = useState([]);
  const [tahunsHonnest, setTahunsHonnest] = useState([]);
  const [rekapPermohonan, setRekapPermohonan] = useState([]);
  const [rekap, setRekap] = useState([]);
  const [provinsi2, setProvinsi2] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // inisialisasi state untuk tahun
  const today = new Date();
  const tahunBerjalan = today.getFullYear();
  const [thnAwal, setThnAwal] = useState(`${tahunBerjalan}-01-01`);
  const [thnAkhir, setThnAkhir] = useState(`${tahunBerjalan}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`);

  // Variabel untuk baca tanggal default
  // const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-11

  // Tahun HACCP
  const [yearHACCP, setYearHACCP] = useState(today.getFullYear());

  // SMKHP
  const [startOfMonth, setStartOfMonth] = useState(new Date(year, month, 1));
  const [endOfMonth, setEndOfMonth] = useState(new Date(year, month + 1, 0)); // 0 = last day of previous month

  // fungsi untuk baca tanggal default untuk PB-UMKU
  const getStartOfYear = () => {
    const now = new Date();
    return `${now.getFullYear()}-01-01`;
  };

  const getToday = () => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  };

  // variabel untuk tanggal awal dan akhir PBUMKU
  const [startDateUmku, setStartDateUmku] = useState(getStartOfYear());
  const [endDateUmku, setEndDateUmku] = useState(getToday());

  // variabel untuk x axis
  const [xAxis, setXAxis] = useState(1);

  // variable baca role
  const [role, setRole] = useState(localStorage.getItem("role"));

  // variabel baca upt
  const [kdUPT, setKdUPT] = useState(localStorage.getItem("kdUnit"));

  const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // bulan dimulai dari 0
    const dd = String(date.getDate()).padStart(2, "0");
    const time = isEndOfDay ? "23:59:59" : "00:00:00";
    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const formatDateInput = (date) => {
    const offset = date.getTimezoneOffset(); // dalam menit
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 10);
  };

  const [selectedBulan, setSelectedBulan] = useState(
    today.toLocaleString("id-ID", { month: "long" }) +
    " " +
    today.toLocaleString("default", { year: "numeric" })
  );
  const [selectedTahun, setSelectedTahun] = useState(
    today.toLocaleString("default", { year: "numeric" })
  );
  const monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MEI",
    "JUN",
    "JUL",
    "AGU",
    "SEP",
    "OKT",
    "NOV",
    "DES",
  ];

  // template startDate dan endDate
  const [tempStartDate, setTempStartDate] = useState(
    formatDateInput(startOfMonth)
  );
  const [tempEndDate, setTempEndDate] = useState(formatDateInput(endOfMonth));

  // template startDate dan endDate PBUMKU
  const [tempStartDateUmku, setTempStartDateUmku] = useState(getStartOfYear());
  const [tempEndDateUmku, setTempEndDateUmku] = useState(getToday());

  // varibel Range Periode
  const [rangePeriode, setRangePeriode] = useState(`Bulan ${selectedBulan}`);
  const [rangePeriodeUmku, setRangePeriodeUmku] = useState(
    `Tahun ${new Date().getFullYear()}`
  );

  useEffect(() => {
    getProvinsiCnt();
    getJumlahPermohonan();
  }, [thnAwal, thnAkhir]);


  const getProvinsiCnt = async () => {
    try {
      const res = await DashService.getPropinsiIzinRekap(
        formatDate(new Date(thnAwal)),
        formatDate(new Date(thnAkhir), true),
        // limitPrimer
      );
      setProvinsi(res.data);
    } catch (err) {
      console.error("❌ Error getProvinsiIzin:", err);
    }
  };

  const getJumlahPermohonan = async () => {
    try {
      const response = await DashService.getRekapPermohonan(
        formatDate(new Date(thnAwal)),
        formatDate(new Date(thnAkhir), true)
      );
      setRekapPermohonan(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickButtonUmku = () => {
    const bulanIndonesia = new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    if (!tempStartDateUmku || !tempEndDateUmku) {
      alert("Tanggal awal dan akhir harus diisi!");
      return;
    }

    const start = new Date(tempStartDateUmku + "T00:00:00"); // buat Date dari string
    const end = new Date(tempEndDateUmku + "T23:59:59");

    if (start > end) {
      alert("Tanggal awal tidak boleh lebih besar dari tanggal akhir.");
      return;
    }

    if (start.getFullYear() !== end.getFullYear()) {
      alert("Periode tidak boleh lintas tahun.");
      return;
    }

    setThnAwal(tempStartDateUmku);
    setThnAkhir(tempEndDateUmku);

    const formattedStart = bulanIndonesia.format(new Date(tempStartDateUmku));
    const formattedEnd = bulanIndonesia.format(new Date(tempEndDateUmku));

    // setRangePeriodeUmku(`Periode ${tempStartDateUmku} s.d ${tempEndDateUmku} (Tahun ${start.getFullYear()})`);
    setRangePeriodeUmku(`Periode ${formattedStart} s.d ${formattedEnd}`);
  };

  const dummyData = useMemo(() => {
    return [
      { label: "Permohonan", count: rekapPermohonan?.totalJumlah || 0 },
      { label: "Total CPIB", count: provinsi?.rekap?.CPIB || 0 },
      { label: "Total CBIB", count: provinsi?.rekap?.CBIB || 0 },
      { label: "Total CPPIB", count: provinsi?.rekap?.CPPIB || 0 },
      { label: "Total CPOIB", count: provinsi?.rekap?.CPOIB || 0 },
      { label: "Total CDOIB", count: provinsi?.rekap?.CDOIB || 0 },
      { label: "Total Terbit", count: provinsi?.rekap?.total || 0 },
    ];
  }, [rekapPermohonan, provinsi]);

  const bgColors = [
    "#FFF3CD", // bg-soft-warning (Permohonan)
    "#E1F0FF", // soft dari #0071CE
    "#FFF2E1", // soft dari #F7941E
    "#FFE6EB", // soft dari #CF0F47
    "#E0F2F1", // soft dari #004D40
    "#E8F5F1", // soft dari #4BA38A
    "#FFE6E0", // soft dari #E6D8AE
  ];

  const iconColors = [
    "#F7941E", // Permohonan
    "#0071CE", // CPIB
    "#FCD58A", // CBIB
    "#CF0F47", // CPPIB
    "#004D40", // CPOIB
    "#4BA38A", // CDOIB
    "#DC3C22", // Total Terbit
  ];

  return (
    <Fragment>
      {!isTrader ? (
        <Fragment>
          {/* Statistik PB-UMKU */}
          <Row style={{ position: "relative", top: "-27px" }}>
            {/* Header */}
            <Col md="12">
              <div className="iq-navbar-header mb-4 px-4 py-3 rounded">
                {/* <div className="iq-navbar-header mb-4 bg-gradient-header"> */}
                <Row className="align-items-center">
                  {/* Kiri: Judul dan Info */}
                  <Col lg={6} md={12} className="mb-3 mb-lg-0">
                    <h2 className="text-white fw-bold mb-1">
                      Sertifikat Mutu Primer
                    </h2>
                    <h2 className="text-light mb-1">BPPMHKP</h2>
                    <h3 className="text-white">{rangePeriodeUmku}</h3>
                  </Col>

                  {/* Kanan: Form Periode */}
                  <Col lg={6} md={12}>
                    <Form.Group className="form-group">
                      <Form.Label className="text-white fw-semibold">
                        Periode
                      </Form.Label>
                      <div className="d-flex gap-2 align-items-end flex-wrap">
                        <div className="d-flex flex-column">
                          <Form.Label className="text-white small mb-1">
                            Dari
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={tempStartDateUmku}
                            onChange={(e) =>
                              setTempStartDateUmku(e.target.value)
                            }
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #ccc",
                              minWidth: "140px",
                            }}
                          />
                        </div>
                        <div className="d-flex flex-column">
                          <Form.Label className="text-white small mb-1">
                            Sampai
                          </Form.Label>
                          <Form.Control
                            type="date"
                            value={tempEndDateUmku}
                            onChange={(e) => setTempEndDateUmku(e.target.value)}
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #ccc",
                              minWidth: "140px",
                            }}
                          />
                        </div>
                        <Button
                          type="button"
                          variant="success"
                          className="mt-auto px-3"
                          onClick={handleClickButtonUmku}
                        >
                          Tampilkan
                        </Button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col md="12" lg="12">

              {/* 2 Card Permohoanan dan Terbit Sertifikat */}
              <Row className="mt-3">
                {dummyData.map((item, index) => (
                  <Col
                    key={index}
                    style={{ flex: "0 0 14.285%", maxWidth: "14.285%" }}
                    className="mb-2"
                  >
                    <div
                      className="shadow-sm rounded p-2"
                      style={{ backgroundColor: bgColors[index], borderRadius: "0.75rem" }}
                    >
                      <div className="d-flex justify-content-between align-items-center rounded p-2">
                        <div
                          className="rounded p-2"
                          style={{ backgroundColor: iconColors[index] }}
                        >
                          {index === 0 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22px"
                              height="22px"
                              viewBox="0 0 22 22"
                            >
                              <path
                                fill="white"  
                                fillRule="evenodd"
                                d="M9.5 12.5537C12.2546 12.5537 14.4626 10.3171 14.4626 7.52684C14.4626 4.73663 12.2546 2.5 9.5 2.5C6.74543 2.5 4.53737 4.73663 4.53737 7.52684C4.53737 10.3171 6.74543 12.5537 9.5 12.5537ZM9.5 15.0152C5.45422 15.0152 2 15.6621 2 18.2464C2 20.8298 5.4332 21.5 9.5 21.5C13.5448 21.5 17 20.8531 17 18.2687C17 15.6844 13.5668 15.0152 9.5 15.0152ZM19.8979 9.58786H21.101C21.5962 9.58786 22 9.99731 22 10.4995C22 11.0016 21.5962 11.4111 21.101 11.4111H19.8979V12.5884C19.8979 13.0906 19.4952 13.5 18.999 13.5C18.5038 13.5 18.1 13.0906 18.1 12.5884V11.4111H16.899C16.4027 11.4111 16 11.0016 16 10.4995C16 9.99731 16.4027 9.58786 16.899 9.58786H18.1V8.41162C18.1 7.90945 18.5038 7.5 18.999 7.5C19.4952 7.5 19.8979 7.90945 19.8979 8.41162V9.58786Z"
                                clipRule="evenodd"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22px"
                              height="22px"
                              viewBox="0 0 22 22"
                            >
                              <path
                                fill="white"
                                fillRule="evenodd"
                                d="M7.81 2H16.191C19.28 2 21 3.78 21 6.83V17.16C21 20.26 19.28 22 16.191 22H7.81C4.77 22 3 20.26 3 17.16V6.83C3 3.78 4.77 2 7.81 2ZM8.08 6.66V6.65H11.069C11.5 6.65 11.85 7 11.85 7.429C11.85 7.87 11.5 8.22 11.069 8.22H8.08C7.649 8.22 7.3 7.87 7.3 7.44C7.3 7.01 7.649 6.66 8.08 6.66ZM8.08 12.74H15.92C16.35 12.74 16.7 12.39 16.7 11.96C16.7 11.53 16.35 11.179 15.92 11.179H8.08C7.649 11.179 7.3 11.53 7.3 11.96C7.3 12.39 7.649 12.74 8.08 12.74ZM8.08 17.31H15.92C16.319 17.27 16.62 16.929 16.62 16.53C16.62 16.12 16.319 15.78 15.92 15.74H8.08C7.78 15.71 7.49 15.85 7.33 16.11C7.17 16.36 7.17 16.69 7.33 16.95C7.49 17.2 7.78 17.35 8.08 17.31Z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </div>
                        <div className="text-end">
                          <h5 className="counter">
                            <CountUp
                              start={item.count - 20}
                              end={item.count}
                              duration={2}
                              separator="."
                            />
                          </h5>
                          {item.label}
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>

            {/* Bagian Grafik Per Provinsi */}
            <Col xs="12" md="12">
              <Card className="h-800 shadow-sm rounded-3 mb-3">
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Grafik Sertifikasi Mutu Primer per Provinsi</h5>
                </Card.Header>
                <Card.Body className="py-2">
                  {/* <Chart options={chartOptions} series={pivotSeries} type="bar" height={400} /> */}
                  <PrimerChart2 rekapPrimer={provinsi.data} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Fragment>
      ) : (
        <Fragment>
          <Row>
            <Col md="12">
              <div className="d-flex justify-content-between flex-wrap iq-navbar-header mb-4">
                <div>
                  <h1 className="text-white">SIAP MUTU</h1>
                  <h3 className="text-light">
                    Sistem Informasi Aplikasi Pelayanan Mutu{" "}
                  </h3>
                </div>
              </div>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
});

export default DashPrimer;
